import { z } from "zod";
import { assetViewSchema, type AssetUpsertPayload } from "../assets/types";
import { assetAssignmentViewSchema } from "../asset-assignments/types";

/**
 * A directory entry returned by the Office API's user-search proxy.
 * The Office backend projects HR's full user record down to just what
 * the SPA's picker needs; this schema mirrors that projection.
 */
export const userDirectoryEntrySchema = z.object({
    id: z.string(),
    displayName: z.string().nullable().optional(),
    email: z.string().nullable().optional(),
    userPrincipalName: z.string().nullable().optional(),
});

export type UserDirectoryEntry = z.infer<typeof userDirectoryEntrySchema>;

export const userSearchResponseSchema = z.object({
    results: z.array(userDirectoryEntrySchema),
});

export type UserSearchResponse = z.infer<typeof userSearchResponseSchema>;

/**
 * Wire shape for the user-anchored "add asset" call. Mirrors the
 * workspace variant — both ids are client-generated for idempotent
 * retry on flaky mobile networks.
 */
export interface AddAssetToUserPayload {
    readonly asset: AssetUpsertPayload;
    readonly assignmentId: string;
}

export const addAssetToUserResponseSchema = z.object({
    asset: assetViewSchema,
    assignment: assetAssignmentViewSchema,
});
export type AddAssetToUserResult = z.infer<typeof addAssetToUserResponseSchema>;
